import { api } from "./api";
import {
  ListRequest,
  ListRequestSchemaV2,
  MessageResponse,
  PaginatedResponse,
} from "../types/common/commonTypes";
import {
  BOMRevFull,
  BOMRevCreate,
  BOMRevUpdate,
  PaginatedBOMRevResponse,
  PaginatedBOMCompResponse,
  BomRevListView,
} from "../types/bomTypes";

/**
 * Inventory Management Service
 *
 * Provides complete integration with all 12 inventory management API endpoints:
 * - Core lot management (CRUD operations)
 * - FIFO allocation engine
 * - Real-time availability tracking
 * - Lot shipping and movement
 * - Comprehensive inventory summaries
 *
 * Auto-generation: Lot numbers are auto-generated by backend (YY-###### format)
 * Example: 24-000001, 24-000002, etc. (resets annually)
 */
const bomrev_base = "/manufacturing/boms/revisions";
const bomcomp_base = "/manufacturing/boms/components";
export const bomService = {
  createBomRev: async (data: BOMRevCreate): Promise<BOMRevFull> => {
    const response = await api.post(`${bomrev_base}/`, data);
    return response.data;
  },
  listBomRev: async (params: ListRequest): Promise<PaginatedBOMRevResponse> => {
    const response = await api.post(`${bomrev_base}/search`, params);
    return response.data;
  },
  listBomRevV2: async (
    params: ListRequestSchemaV2,
  ): Promise<PaginatedResponse<BomRevListView>> => {
    const response = await api.post(`${bomrev_base}/list_view`, params);
    return response.data;
  },
  getBomRevById: async (id: string): Promise<BOMRevFull> => {
    const response = await api.get(`${bomrev_base}/${id}`);
    return response.data;
  },
  updateBomRev: async (id: string, data: BOMRevUpdate): Promise<BOMRevFull> => {
    const response = await api.put(`${bomrev_base}/${id}`, { ...data, id });
    return response.data;
  },
  deactivateBomRev: async (id: string): Promise<MessageResponse> => {
    const response = await api.delete(`${bomrev_base}/${id}`);
    return response.data;
  },
  reactivateBomRev: async (id: string): Promise<BOMRevFull> => {
    const response = await api.post(`${bomrev_base}/${id}/restore`);
    return response.data;
  },
  listBomComp: async (
    params: ListRequestSchemaV2,
  ): Promise<PaginatedBOMCompResponse> => {
    const response = await api.post(`${bomcomp_base}/list_view`, params);
    return response.data;
  },
  getBomCompsByRev: async (
    revId: string,
  ): Promise<PaginatedBOMCompResponse> => {
    const response = await api.get(`${bomcomp_base}/by_rev/${revId}`);
    return response.data;
  },
};
